import { baseApi } from "./baseApi";

const JSON_HEADERS = {
  "Content-type": "application/json; charset=UTF-8",
};

export const analyticsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAnalyticsOverview: builder.query({
      query: (range = "28d") => ({
        url: `analytics/overview?range=${encodeURIComponent(range)}`,
        method: "GET",
        headers: JSON_HEADERS,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const { useGetAnalyticsOverviewQuery } = analyticsApi;
